﻿'use strict';

angular.module('ntmApp')
  .filter('take', function () {

      return function (array, takeCount) {
          
          if (array) {
              return array.slice(0, takeCount);
          }

          return array;
      };
  });